<template>
  <div>
    <div style="margin-bottom: 15px; font-weight: bold">订单最近三笔流水</div>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="billTypeName" label="账期类型" />
        <el-table-column prop="payTypeName" label="付款类型" />
        <el-table-column prop="amount" label="金额" />
        <el-table-column prop="createTime" label="支付时间" />
      </el-table>
    </div>
  </div>
</template>

<script>
import { getListAPI } from "./api";

export default {
  name: "OrderBills",

  props: {
    pageSize: {
      type: Number,
      default: 3,
    },
    orderNo: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      tableData: [],
    };
  },

  watch: {
    orderNo: {
      handler(newVal) {
        if (!newVal) {
          return;
        }

        this.getTableData();
      },
    },
  },

  mounted() {
    this.getTableData();
  },

  methods: {
    async getTableData() {
      if (!this.orderNo) {
        return;
      }

      const res = await getListAPI({
        page: 1,
        pageSize: this.pageSize,
        orderNo: this.orderNo,
      });

      this.tableData = res.list;
    },
  },
};
</script>
